import * as reactRouterDom from "react-router-dom";
import Typography from "@mui/material/Typography";
import { Box, Button } from "@mui/material";
import Page from "../page";

const NotAuthorizedPage = () => {
  const navigate = reactRouterDom.useNavigate();

  const handleClick = () => {
    navigate("/");
  };

  return (
    <Page withFooter={false}>
      <Typography
        align="center"
        variant="h3"
        component="h1"
        color="textPrimary"
        sx={{ marginBottom: 4, marginTop: 4 }}
      >
        403: Not Authorized
      </Typography>
      <Typography align="center" variant="subtitle2" color="textSecondary">
        You do not have permission to view this page. Please contact your
        administrator or return to the homepage.
      </Typography>
      <Box mt={5} display="flex" justifyContent="center">
        <Button
          color="primary"
          variant="outlined"
          onClick={handleClick}
          type="button"
        >
          Back to home
        </Button>
      </Box>
      <Box mt={8} display="flex" justifyContent="center">
        <img
          src="not-authorized-dog.png"
          alt="Not Authorized"
          style={{ maxWidth: "100%", height: "300px" }}
        />
      </Box>
    </Page>
  );
};

export default NotAuthorizedPage;
